import { languageHelper } from "../../../config/helperFunctions";
import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { FaCheck, FaRegFilePdf, FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";

function SubscriptionManagement() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper("SN"),
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Customer Name"),
      accessorKey: "customer_name",
    },
    {
      header: languageHelper("Phone"),
      accessorKey: "phone",
    },
    {
      header: languageHelper("Package Name"),
      accessorKey: "heading",
    },
    {
      header: languageHelper("Amount"),
      accessorKey: "amount",
    },
    {
      header: languageHelper("Expire Date"),
      accessorKey: "expire_date",
    },
    {
      header: languageHelper("Status"),
      accessorKey: "status",
      cell: (row) => (row.getValue() === 0 ? "Pending" : "Approved"),
    },

    {
      header: languageHelper("Actions"),
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ];
  const [data, setData] = useState([]);

  const dropdownOptions = [
    {
      name: languageHelper("Approve"),
      icon: <FaCheck />,
      func: (id) => {
        approveSubscriber(id);
      },
    },
    {
      name: languageHelper("Generate Card"),
      icon: <FaRegFilePdf />,
      func: (id) => {
        generateCard(id);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrash />,
      func: (id) => {
        deleteSubscriber(id);
      },
    },
  ];

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/subscriber`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(
          res.data.map((item) => ({
            ...item,
            customer_name: item?.customers?.name,
            phone: item?.customers?.phone,
          }))
        );
      })
      .catch((err) => {});
  }, [user?.token]);

  const approveSubscriber = (id) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/subscriber/approve/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const generateCard = (id) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/subscriber/card/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const deleteSubscriber = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/subscriber/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <main>
      <CardTable
        heading={languageHelper("Subscription Management")}
        data={data}
        columns={columns}
      />
    </main>
  );
}

export default SubscriptionManagement;
